"use client";

import { IconCircleCheck } from "central-icons/IconCircleCheck";
import { IconCircleX } from "central-icons/IconCircleX";
import { AnimatePresence, m } from "motion/react";
import { useState } from "react";
import DemoCheckbox from "@/components/preview/demo-checkbox";
import DemoFooter from "@/components/preview/demo-footer";
import DemoWrapper from "@/components/preview/demo-wrapper";
import { Button } from "@/components/ui/button";

export default function UiShadowsDemo() {
  const [showBackground, setShowBackground] = useState(false);

  return (
    <DemoWrapper margin="">
      <div className="relative flex h-52 w-full flex-col items-center justify-center gap-4 overflow-hidden sm:flex-row">
        <AnimatePresence>
          {showBackground && (
            <m.div
              animate={{ opacity: 1 }}
              className="absolute inset-0 bg-linear-to-b from-gray-900 to-gray-800 will-change-[opacity]"
              exit={{ opacity: 0 }}
              initial={{ opacity: 0 }}
              transition={{ duration: 0.25, ease: "easeOut" }}
            />
          )}
        </AnimatePresence>

        <Button
          className="relative z-10 gap-2 border border-gray-400 bg-preview-bg pr-5 pl-3 text-lg shadow-none hover-hover:hover:border-gray-500 hover-hover:hover:bg-preview-bg"
          leftIcon={
            <div className="flex size-6 items-center justify-center rounded-full bg-gray-300">
              <IconCircleX className="size-4.5 text-gray-900" />
            </div>
          }
          rounded
          size="xl"
          type="button"
          variant="secondary"
        >
          Border
        </Button>
        <Button
          className="relative z-10 gap-2 pr-5 pl-3 text-lg transition-[box-shadow,background-color,scale] duration-200 ease-out hover-hover:hover:bg-gray-200 hover-hover:hover:shadow-custom-hover"
          leftIcon={
            <div className="flex size-6 items-center justify-center rounded-full bg-sky-500/10">
              <IconCircleCheck className="size-4.5 text-sky-500" />
            </div>
          }
          rounded
          size="xl"
          type="button"
          variant="secondary"
        >
          Shadow
        </Button>
      </div>
      <DemoFooter>
        <DemoCheckbox
          checked={showBackground}
          label="Show background"
          onCheckedChange={setShowBackground}
        />
      </DemoFooter>
    </DemoWrapper>
  );
}
